import React, { useMemo } from 'react';

import { withSideNavigationAnalyticsContext } from '../common/analytics/context';
import type { GlobalSideNavigationProps } from '../common/types';

import { GlobalSideNavigationWithLocalStore } from './side-nav/GlobalSideNavWithLocalStore';
import { GlobalSideNavigationWithNetworkStore } from './side-nav/GlobalSideNavWithNetworkStore';

export const GlobalSideNavigation = withSideNavigationAnalyticsContext(RawGlobalSideNavigation);

function RawGlobalSideNavigation(props: GlobalSideNavigationProps) {
	const { customizationStore = 'local', ...innerProps } = props;

	const SideNav = useMemo(() => {
		return customizationStore === 'local'
			? GlobalSideNavigationWithLocalStore
			: GlobalSideNavigationWithNetworkStore;
	}, [customizationStore]);

	return <SideNav {...innerProps} />;
}
